import {format} from 'utils'
import request from 'crm/utils/request'
import api from './api'

export async function detail(payload) {
    return request(format(api.detail.url, {id: payload.id}))
}

export async function create(payload) {
    return request(api.create.url, {
        method: api.create.type,
        body: payload.body,
    })
}

export async function update(payload) {
    return request(format(api.update.url, {id: payload.id}), {
        method: api.update.type,
        body: payload.body,
    })
}
